import {Link, useLoaderData, useRouteLoaderData} from '@remix-run/react'
import {slugToText} from '@roundforest/text-transforms-commons'
import clsx from 'clsx'
import type {FunctionComponent} from 'react'
import React, {Fragment} from 'react'
import {getDomainConfig} from '~/domains'
import {useReportWidgetClick, useReportWidgetSeen} from '~/hooks/analytic-hooks'
import type {CategoriesDataProps, RootLoaderResponse} from '~/types'

interface CategoriesProps {
  from: number
  to: number
}
const Categories: FunctionComponent<CategoriesProps> = ({from = 0, to = Infinity}) => {
  const {domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {newHomePageData} = useLoaderData() as CategoriesDataProps
  const {categorySpotlight} = newHomePageData?.homepageData || {}
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)
  const categoriesToDisplay = categorySpotlight?.slice(from, to)

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'category-spotlight',
    widget_place: 'middle',
    variation: `${from}-${to}`,
  })

  const reportWidgetClick = useReportWidgetClick()

  const displayItems = categoriesToDisplay && categoriesToDisplay?.length > 1

  return (
    displayItems && (
      <div
        className={clsx(
          'mx-auto my-10 flex flex-col gap-4',
          stylesBydomain.UTILS_MAIN_CONTAINER,
          'utils_main_container',
        )}
        ref={widgetRef}
      >
        <div className="grid grid-cols-4 gap-4 tablet:grid-cols-2">
          {categoriesToDisplay?.map(({slug, image}, i) => {
            const categoryName = slugToText(slug)
            return (
              <Fragment key={`${categoryName}-${i}`}>
                <Link
                  to={`/${slug}`}
                  prefetch="intent"
                  aria-label={`view ${categoryName}`}
                  className="mx-auto flex !w-fit flex-col items-center justify-start gap-1 tablet:min-w-full"
                  onClick={() =>
                    reportWidgetClick({
                      widget_name: 'category-spotlight',
                      widget_place: `${from}-${to}`,
                      trigger_type: categoryName,
                    })
                  }
                >
                  <div
                    className={clsx(
                      'flex h-48 w-56 items-center justify-center rounded-xl border-2 tablet:w-full',
                      stylesBydomain.HOMEPAGE_CATEGORIES_CARD_BORDER,
                      'homepage_categories_card_border',
                    )}
                  >
                    <img src={image} alt={categoryName} className="size-40 object-scale-down" loading="lazy" />
                  </div>
                  <span className="text-base font-normal capitalize text-black">{categoryName}</span>
                </Link>
              </Fragment>
            )
          })}
        </div>
      </div>
    )
  )
}
export default Categories
